module.exports = __webpack_public_path__ + "img/banner_culture.2d35fd68.png";